<template>
    <section id="content" class="gray-area">
        <div class="container">
            <!-- >>> 'BreadCrumbs' - Row -->
            <div class="row">
                <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                <sdr-breadcrumbs active_item="fourth" :module="modulo"></sdr-breadcrumbs>
                <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
            </div>
            <!-- <<< 'BreadCrumbs' - Row -->

            <!-- >>> 'Overview' - Row -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px;">
                        <span class="index">
                            <i class="soap-icon-arrow-right circle"></i>
                        </span>
                        {{ pleaseselectoverview[getCurrentLocale] }}
                    </h1>
                </div>

                <!-- >>>  Left Side: : 'Overview' -->
                <form @submit.prevent="onSubmit">
                    <div id="main" class="col-sms-6 col-sm-8 col-md-9">

                        <!-- >>> Agency -->
                        <div class="pull-right" style="color: red; font-size: 18px; margin-bottom: 15px;" v-if="getFlagSharedAgencyLoggedIn === true">{{ agencycommision[getCurrentLocale] }} {{ getSharedAgencyLoginResultsAmountAndValue(modulo) }}</div>

                        <!-- >>> Booking Details -->
                        <div id="flight-features" class="tab-container">
                            <!-- >>> TabHeader:  -->
                            <ul class="tabs">
                                <li class="active">
                                    <a
                                        href="#flight-details"
                                        data-toggle="tab"
                                    >{{ tab_flightdetails[getCurrentLocale] }}</a>
                                </li>
                                <!-- <li><a href="#inflight-features" data-toggle="tab">{{ tab_inflightfeatures[getCurrentLocale] }}</a></li> -->
                            </ul>
                            <!-- <<< TabHeader:  -->

                            <!-- >>> Tab Content: -->
                            <div class="tab-content">
                                <!-- --------------------------------------- -->
                                <!-- >>> Tab: 'flight-details' -->
                                <div class="tab-pane fade in active" id="flight-details">
                                    <!-- >>> VueCmp - 'sdr-flight-details', 'Flight Details', Outward -->
                                    <sdr-flight-details flightdirection="outward" :modulo="modulo"></sdr-flight-details>
                                    <!-- <<< VueCmp - 'sdr-flight-details', 'Flight Details', Outward -->

                                    <!-- >>> 'Return Flight' Part -->
                                    <div v-if="getBookingFlightIdSelectedReturn !== null">
                                        <br />
                                        <hr />
                                        <br />
                                        <!-- >>> VueCmp - 'sdr-flight-details', 'Flight Details', Return -->
                                        <sdr-flight-details flightdirection="return" :modulo="modulo"></sdr-flight-details>
                                        <!-- <<< VueCmp - 'sdr-flight-details', 'Flight Details', Return -->
                                    </div>
                                    <!-- <<< 'Return Flight' Part -->

                                    <!-- >>> Total::Total::Total -->
                                    <br />
                                    <button
                                        type="button"
                                        class="btn-large full-width totalbutton sundair"
                                        v-bind:class="{ sundairsrvcs: modulo === 'services' }"
                                        style="cursor: initial; outline: none !important; outline-style: none !important;"
                                    >
                                        {{ Number(getBookingCartOutwardTotal) + Number(getBookingCartReturnTotal) | rndAmntRUAFWZ }}
                                        <br />
                                        <span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span>
                                    </button>
                                    <!-- <<< Total::Total::Total -->
                                </div>
                                <!-- <<< Tab: 'flight-details' -->
                                <!-- --------------------------------------- -->
                            </div>
                            <!-- <<< Tab Content: -->
                        </div>
                        <!-- <<< Booking Details -->

                        <br />
                        <!-- >>> Payment Details -->
                        <div class="booking-information sdr-box" v-if="modulo === 'booking'">
                            <h2>{{ payment[getCurrentLocale] }}:</h2>
                            <dl class="term-description">
                                <dt>{{ payment_firstname[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.firstName }}</dd>
                                <dt>{{ payment_lastname[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.lastName }}</dd>
                                <dt>{{ payment_email[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.email }}</dd>
                                <dt>{{ payment_phone[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.phone }}</dd>
                                <dt>{{ payment_address[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.address }}</dd>
                                <dt>{{ payment_zipcode[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.zipCode }}</dd>
                                <dt>{{ payment_city[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.city }}</dd>
                                <dt>{{ payment_countrycode[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.countryCode }}</dd>
                            </dl>
                            <hr />
                            <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                            <p>{{ forsecurity[getCurrentLocale] }}</p>
                            <br />
                            <p class="red-color" v-if="getBookingProcessBookingObject.payment.type !== 'OO'">
                                {{ paymentismadeby[getCurrentLocale] }}
                                {{ getBookingProcessBookingObject.payment.ccPayment !== undefined ? creditcard[getCurrentLocale] : null }}
                                {{ getBookingProcessBookingObject.payment.ddPayment !== undefined ? debit[getCurrentLocale] : null }}
                                {{ getBookingProcessBookingObject.payment.type === 'CS' ? cashpayment[getCurrentLocale] : null }}
                            .</p>
                        </div>

                        <div class="booking-information sdr-box" v-if="modulo === 'services' ">
                            <h2>{{ payment[getCurrentLocale] }}:</h2>
                            <dl class="term-description">
                                <dt>{{ payment_firstname[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.firstName }}</dd>
                                <dt>{{ payment_lastname[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.lastName }}</dd>
                                <dt>{{ payment_email[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.email }}</dd>
                                <dt>{{ payment_phone[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.phone }}</dd>
                                <dt>{{ payment_address[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.address }}</dd>
                                <dt>{{ payment_zipcode[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.zipCode }}</dd>
                                <dt>{{ payment_city[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.city }}</dd>
                                <dt>{{ payment_countrycode[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.countryCode }}</dd>
                            </dl>
                            <hr />
                            <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                            <p>{{ forsecurity[getCurrentLocale] }}</p>
                            <br />
                            <p class="red-color" v-if="getServicesProcessBookingObject.payment.type !== 'OO'">
                                {{ paymentismadeby[getCurrentLocale] }}
                                {{ getServicesProcessBookingObject.payment.ccPayment !== undefined ? creditcard[getCurrentLocale] : null }}
                                {{ getServicesProcessBookingObject.payment.ddPayment !== undefined ? debit[getCurrentLocale] : null }}
                                {{ getServicesProcessBookingObject.payment.type === 'CS' ? cashpayment[getCurrentLocale] : null }}

                            .</p>
                        </div>
                        <!-- <<< Payment Details -->


                        <!-- >>> DD 2FA Banner -------------------------------- -->
                        <div class="booking-section sdr-box" v-if="dd2faRequiredForFlow && isDdPayment">
                            <div class="dd-2fa-banner" :class="{ 'dd-2fa-banner--done': dd2faLocallyComplete }">
                                <div class="dd-2fa-banner__body">
                                    <span class="dd-2fa-banner__step">{{ dd2faStepLabel[getCurrentLocale] }}</span>
                                    <div class="dd-2fa-banner__content">
                                        <i class="fa fa-shield" v-if="!dd2faLocallyComplete"></i>
                                        <i class="fa fa-check-circle" v-else></i>
                                        <div>
                                            <strong>{{ dd2faActionTitle[getCurrentLocale] }}</strong>
                                        </div>
                                    </div>
                                </div>
                                <div class="dd-2fa-banner__action">
                                    <button
                                        v-if="!dd2faLocallyComplete"
                                        type="button"
                                        class="button btn-medium uppercase dd-2fa-open-btn"
                                        @click.prevent="openDd2faModal">
                                        {{ dd2faOpenModal[getCurrentLocale] }}
                                    </button>
                                    <span class="dd-2fa-done" v-else>
                                        <i class="soap-icon-check-1"></i> {{ dd2faDone[getCurrentLocale] }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!-- <<< DD 2FA Banner -------------------------------- -->


                        <!-- >>> Confirm CheckBoxes -->
                        <div class="booking-section sdr-box dd-2fa-checkboxes-wrap" :class="{ 'dd-2fa-checkboxes-wrap--locked': areCheckboxesLocked }">
                            <!-- >>> Payment: CheckBoxes to Confirm/Check -->
                            <div class="container shortcode travel-ideas">
                                <h2 class="idea-title red-color" style="margin-bottom:15px;">
                                    <span class="index" style="background: #D13E47;">
                                        <i class="soap-icon-notice circle"></i>
                                    </span>
                                    {{ pleaseconfirm[getCurrentLocale] }}:
                                </h2>
                            </div>
                            <div class="form-group">
                                <!-- >>> Confirm - ABB -->
                                <!-- <p-check class="p-svg p-round p-pulse" color="success" value="ABB" v-model="checkedBoxes" id="check">
                                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                        <path
                                            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                            style="stroke: white;fill:white"
                                        />
                                    </svg>
                                </p-check>&nbsp;
                                <a href="#" v-on:click.prevent="call_getwebcomponent('ABB')">
                                    <span class="xskin-color" style="font-size: 1.0833em;" >{{ form_confirmabb_1[getCurrentLocale] }}</span>
                                </a> -->
                                <!-- <<< Confirm - ABB -->


                                <!-- >>> Confirm - AGB -->
                                <br />
                                <p-check class="p-svg p-round p-pulse" color="success" value="AGB" v-model="checkedBoxes" id="check">
                                    <!-- svg path -->
                                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                        <path
                                            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                            style="stroke: white;fill:white"
                                        />
                                    </svg>
                                </p-check>&nbsp;
                                <a href="#" v-on:click.prevent="call_getwebcomponent('AGB')">
                                    <span class="xskin-color" style="font-size: 1.0833em;" >{{ form_confirmagb_1[getCurrentLocale] }}</span>
                                </a>
                                <!-- <<< Confirm - ABB -->





                                <!-- >>> Confirm - Privacy -->
                                <br />
                                <p-check class="p-svg p-round p-pulse" color="success" value="PRIVACY" v-model="checkedBoxes" id="check">
                                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                                        <path
                                            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                                            style="stroke: white;fill:white"
                                        />
                                    </svg>
                                </p-check>&nbsp;
                                <a href="#" v-on:click.prevent="call_getwebcomponent('PCPE')">
                                    <span class="xskin-color" style="font-size: 1.0833em;">{{ form_confirmprivacy_1[getCurrentLocale] }}</span>
                                </a>

                                <!-- <<< Confirm - Privacy -->


                            </div>
                            <!-- <<< Payment: CheckBoxes to Confirm/Check -->
                            <div
                                class="dd-2fa-checkboxes-lock-overlay"
                                v-if="areCheckboxesLocked"
                                @click.prevent="openDd2faModal">
                                <div class="dd-2fa-checkboxes-lock-message">
                                    <i class="fa fa-lock"></i>
                                    <strong>{{ dd2faLockTitle[getCurrentLocale] }}</strong>
                                    <span>{{ dd2faLockHint[getCurrentLocale] }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- <<< Confirm CheckBoxes -->


                        <a class="button btn-large uppercase full-width silver" v-if="getFlagBookingOverviewIsReadyForProcess !== true">{{ proceed[getCurrentLocale] }}</a>
                        <button type="submit" class="btn-large icon-check uppercase full-width" v-if="getFlagBookingOverviewIsReadyForProcess === true" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }">{{ proceed[getCurrentLocale] }}</button>
                    </div>
                </form>
                <!-- <<<  Left Side: : 'Overview' -->



                <!-- >>>  Right Side: Sidebar, 'Overview' -->
                <div class="sidebar col-sms-6 col-sm-4 col-md-3">
                    <!-- >>> VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                    <sdr-shared-cart :modulo="modulo"></sdr-shared-cart>
                    <!-- <<< VueCmp - 'sdr-shared-cart', 'Shared Cart' -->

                    <!-- >>> VueCmp - 'sdr-contact-box', 'Contact Box' -->
                    <sdr-contact-box></sdr-contact-box>
                    <!-- <<< VueCmp - 'sdr-contact-box', 'Contact Box' -->
                </div>
                <!-- <<<  Right Side: Sidebar, 'Overview' -->
            </div>
            <!-- <<< 'Overview' - Row -->
        </div>



        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal
            name="size-modal2"
            transition="nice-modal-fade"
            classes="demo-modal-class"
            :min-width="200"
            :min-height="200"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            xwidth="40%"
            height="auto"
            @before-open="beforeOpen"
            @opened="opened"
            @closed="closed"
            @before-close="beforeClose">
            <div class="size-modal2-content">
                <h2>{{ webcomponenttype }}</h2>
                <span v-if="sections.length > 1">
                    <div
                        class="toggle-container box"
                        id="accordion1"
                        v-for="(section, index) in sections"
                        :key="index"
                        style="margin-bottom:0px;"
                    >
                        <div class="panel style1">
                            <h4 class="panel-title">
                                <a
                                    class="collapsed"
                                    v-bind:href="'#acc1_' + index"
                                    data-toggle="collapse"
                                    data-parent="#accordion1"
                                >{{ section.title }}</a>
                            </h4>
                            <div class="panel-collapse collapse" v-bind:id="'acc1_' + index">
                                <div class="panel-content">
                                    <span v-html="section.content"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>

                <span v-if="sections.length === 1">
                    <div class="panel style1">
                        <span v-html="sections[0].content"></span>
                    </div>
                </span>
            </div>
        </modal>

        <sdr-dd-2fa-modal @dd-2fa-confirmed="onDd2faConfirmed"></sdr-dd-2fa-modal>
    </section>
</template>

<script>
    import FlightDetails from '../../booking/overview/FlightDetails.vue';
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import ContactBox from '../../shared/sidebar/ContactBox.vue';
    import SharedCart from '../../shared/cart/Cart.vue';
    import Dd2faModal from '../../shared/payment/Dd2faModal.vue';

    import axios from 'axios';
    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'], // via: router/push
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-flight-details': FlightDetails,
            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-contact-box': ContactBox,
            'sdr-shared-cart': SharedCart,
            'sdr-dd-2fa-modal': Dd2faModal,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                listpoint_agb: {
                    en: 'General Terms',
                    de: 'AGB',
                },
                listpoint_abb: {
                    en: 'Terms and Conditions',
                    de: 'ABB',
                },
                listpoint_pcp: {
                    en: 'Dangerous goods',
                    de: 'Gefährliche Gegenstände',
                },
                listpoint_impressum: {
                    en: 'Imprint',
                    de: 'Impressum',
                },
                listpoint_sec: {
                    en: 'Data Protection & Privacy',
                    de: 'Datenschutz',
                },
                pleaseselectoverview: {
                    en: 'Step 4: Please check again your details.',
                    de: 'Schritt 4: Bitte überprüfen Sie noch einmal Ihre Angaben.'
                },
                // >>> --------------------------
                outwardflight: {
                    en: 'Outward',
                    de: 'Hinflug'
                },
                returnflight: {
                    en: 'Return',
                    de: 'Rückflug'
                },
                tab_flightdetails: {
                    en: 'Your booking overview',
                    de: 'Ihre Buchungsübersicht'
                },
                tab_inflightfeatures: {
                    en: 'Inflight Features',
                    de: 'Funktionen an Bord'
                },
                tab_baggage: {
                    en: 'Baggage',
                    de: 'Gepäck'
                },
                tab_farerules: {
                    en: 'Fare Rules',
                    de: 'Tarifbestimmungen'
                },
                from: {
                    en: 'From',
                    de: 'Von'
                },
                to: {
                    en: 'to',
                    de: 'nach'
                },
                tab_header_flightdetails: {
                    en: 'Your flight and booking details for the outbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Hinflug'
                },
                tab_header_flightdetailsreturn: {
                    en: 'Your flight and booking details for the inbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Rückflug'
                },
                tab_header_inflightfeatures: {
                    en: 'For your well-being on board',
                    de: 'Für Ihr Wohlbefinden an Bord'
                },
                tab_header_farerulesforyourflight: {
                    en: 'Fare Rules for your Flight',
                    de: 'Tarifregeln für Ihren Flug'
                },
                // >>> --------------------------
                adult: {
                    en: 'Adult',
                    de: 'Erwachsener',
                },
                child: {
                    en: 'Child',
                    de: 'Kind',
                },
                infant: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                // >>> --------------------------
                airline: {
                    en: 'Airline',
                    de: 'Airline',
                },
                flighttype: {
                    en: 'Flight Type',
                    de: 'Tarif',
                },
                cancellation: {
                    en: 'Cancellation',
                    de: 'Stornierung',
                },
                flightchange: {
                    en: 'Flight Change',
                    de: 'Umbuchung',
                },
                seatsandbaggage: {
                    en: 'Seats & Baggage',
                    de: 'Sitze & Gepäck',
                },
                extracharge: {
                    en: 'Extra Charge',
                    de: 'Aufpreis'
                },
                avgpers: {
                    en: 'AVG/PAX',
                    de: 'PRO PAX'
                },
                // >>> --------------------------
                mr: {
                    en: 'Mr',
                    de: 'Herr',
                },
                mrs: {
                    en: 'Mrs',
                    de: 'Frau',
                },
                chd: {
                    en: 'Child',
                    de: 'Kind',
                },
                inf: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                born: {
                    en: 'Born',
                    de: 'Geb. am',
                },
                // >>> --------------------------
                form_confirmabb_1 : {
                    en: 'By continuing, you agree to the Terms and Conditions.',
                    de: 'Ich habe die ABBs gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmagb_1 : {
                    en: 'I confirm that I am 18 years or older and I have read and agree to the General Terms.',
                    de: 'Ich bestätige, dass ich 18 Jahre oder älter bin und ich habe die AGB gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmdangerous_1 : {
                    en: 'I have read the information on the carriage of dangerous goods and agree to it.',
                    de: 'Ich habe die Informationen zur Beförderung gefährlicher Gegenstände gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmprivacy_1 : {
                    en: 'I have read the privacy policy and agree to it.',
                    de: 'Ich habe die Datenschutzerklärung gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmadditional_1 : {
                    en: 'I have noted the charges for additional services and agree to it.',
                    de: 'Ich habe die Entgelte für Zusatzleistungen zur Kenntnis genommen und erkläre mich damit einverstanden.',
                },
                pleaseclickallcheckboxes : {
                    en: 'Please confirm all Checkboxes.',
                    de: 'Bitte bestätigen sie alle Checkboxen.',
                },
                // >>> --------------------------
                travelerinformation: {
                    en: 'Traveler Information',
                    de: 'Reisende Infos',
                },
                payment: {
                    en: 'Your Payment details',
                    de: 'Ihre Zahlungsdetails',
                },
                paymentmethod : {
                    en: 'Your Payment method',
                    de: 'Ihre Zahlungsmethode',
                },
                forsecurity: {
                    en: 'For security reasons we do not write out your complete payment data here.',
                    de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.',
                },
                paymentismadeby : {
                    en: 'Payment is made by ',
                    de: 'Die Zahlung erfolgt durch ',
                },
                creditcard: {
                    en: 'Creditcard',
                    de: 'Kreditkarte',
                },
                debit: {
                    en: 'Direct Debit',
                    de: 'Überweisung',
                },
                cashpayment: {
                    en: 'Cash',
                    de: 'Barzahlung',
                },
                payment_firstname: {
                    en: 'FIRST NAME',
                    de: 'Vorname',
                },
                payment_lastname: {
                    en: 'LAST NAME',
                    de: 'Nachname',
                },
                payment_email: {
                    en: 'EMAIL ADDRESS',
                    de: 'E-Mail',
                },
                payment_phone: {
                    en: 'Phone',
                    de: 'Telefon',
                },
                payment_address: {
                    en: 'STREET ADDRESS AND NUMBER',
                    de: 'Adresse',
                },
                payment_zipcode: {
                    en: 'ZIP CODE',
                    de: 'PLZ',
                },
                payment_city: {
                    en: 'TOWN / CITY',
                    de: 'Wohnort',
                },
                payment_countrycode: {
                    en: 'COUNTRY',
                    de: 'Land',
                },
                // >>> --------------------------
                pleaseconfirm: {
                    en: 'Please confirm',
                    de: 'Bitte bestätigen Sie',
                },
                flightprice : {
                    en: 'Flight price',
                    de: 'Flugpreis',
                },
                tincludedtaxes: {
                    en: 'incl. Taxes, Fees & Surcharges',
                    de: 'inkl. Steuern, Gebühren & Zuschlägen',
                },
                total : {
                    en: 'Total',
                    de: 'Gesamt',
                },
                totaloutwardprice: {
                    en: 'Total Outward',
                    de: 'Gesamt Hinflug',
                },
                totalreturnprice: {
                    en: 'Total Return',
                    de: 'Gesamt Rückflug',
                },
                // >>> --------------------------
                inflightfeatures_wifi: {
                    en: 'WI_FI',
                    de: 'WI_FI',
                },
                inflightfeatures_entertainment: {
                    en: 'Entertainment',
                    de: 'Entertainment',
                },
                inflightfeatures_television: {
                    en: 'Television',
                    de: 'Fernsehen',
                },
                inflightfeatures_television: {
                    en: 'Television',
                    de: 'Fernsehen',
                },
                inflightfeatures_airconditioning: {
                    en: 'Air conditioning',
                    de: 'Klimatisierung',
                },
                inflightfeatures_drink: {
                    en: 'Drink',
                    de: 'Getränke',
                },
                inflightfeatures_drink: {
                    en: 'Drink',
                    de: 'Getränke',
                },
                inflightfeatures_games: {
                    en: 'Games',
                    de: 'Spiele',
                },
                inflightfeatures_coffee: {
                    en: 'coffee',
                    de: 'Kaffee',
                },
                inflightfeatures_wines: {
                    en: 'Wines',
                    de: 'Weine',
                },
                inflightfeatures_shopping: {
                    en: 'Shopping',
                    de: 'Shopping',
                },
                inflightfeatures_food: {
                    en: 'Food',
                    de: 'Essen',
                },
                inflightfeatures_comfort: {
                    en: 'Comfort',
                    de: 'Komfort',
                },
                inflightfeatures_magazines: {
                    en: 'Magazines',
                    de: 'Zeitschriften',
                },
                agencycommision: {
                    en: 'Your agency commision is: ',
                    de: 'Ihre Agentur-Provision ist: ',
                },
                // >>> --------------------------
                inthissection: {
                    en: "In this section you'll find information on baggage allowances, special equipment and sports items as well as restricted items. We've also included some tips to make your trip more enjoyable.",
                    de: 'In diesem Abschnitt finden Sie Informationen über Freigepäck, Sonderausstattungen und Sportartikel sowie eingeschränkte Gegenstände. Wir haben auch einige Tipps beigefügt, um Ihre Reise noch angenehmer zu gestalten.',
                },
                // >>> --------------------------
                proceed: {
                    en: 'BOOK WITH OBLIGATION TO PAY',
                    de: 'ZAHLUNGSPFLICHTIG BUCHEN',
                },
                dd2faOpenModal: {
                    en: 'Start SMS verification',
                    de: 'SMS-Verifizierung starten',
                },
                dd2faActionTitle: {
                    en: 'SMS verification required',
                    de: 'SMS-Verifizierung erforderlich',
                },
                dd2faStepLabel: {
                    en: 'Required before checkout',
                    de: 'Pflichtschritt vor Buchungsabschluss',
                },
                dd2faDone: {
                    en: 'PIN entered',
                    de: 'PIN eingegeben',
                },
                dd2faLockTitle: {
                    en: 'PIN verification first',
                    de: 'Zuerst PIN-Zertifizierung',
                },
                dd2faLockHint: {
                    en: 'Tap here or use the button above to start SMS verification.',
                    de: 'Hier tippen oder oben „SMS-Verifizierung starten“.',
                },
                threedsecurecancelled: {
                    en: '3D Secure Proceedure canceled.',
                    de: '3D Secure Vorgang abgebrochen.',
                },
                // >>> -------------------------- Modal WireCard
                AcsUrl: null,
                PaReq: null,
                TermUrl: null,
                OutputFrameSrc: null,

                // >>> -------------------------- Modal

                // currentLocale: 'de',
                // >>> -------------------------- Modal
                webcomponenttype: '', // ABB/FAQ aso.
                sections: [], // data
                // >>> --------------------------
                checkedBoxes: [],
                dd2faLocallyComplete: false,
                dd2faSecret: '',
                dd2faKeyCode: '',
                dd2faPinError: '',
                // >>> --------------------------
                bankaccount_holder: null,
                bankaccount_no: null,
                bankaccount_bankno: null,
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getFlagBookingOverviewIsReadyForProcess',
                'getBookingProcessBookingObject',
                'getBookingFlightIdSelectedReturn', // got RET Flight?
                'getBookingCart', // Pax per Pax
                'getBookingCartOutwardTotal', // Summed up Outward ALL
                'getBookingCartReturnTotal', // Summed up Return ALL
                // >>> --------------------------
                'getServicesProcessBookingObject', // object fpr process booking
                'getFlagSharedAgencyLoggedIn', // Agency
                'getSharedAgencyLoginResultsAmountAndValue', // Agency (Parts)
                // >>> --------------------------
                'getBookingWireCardEnrollPaymentResults',

                'getServicesValidatePassengersObject',
                'getBookingValidatePassengersResponseObject',
                'getBookingDd2faRequired',
                'getServicesDd2faRequired',
                'getServicesTwoFaKeyCode',
                'getBookingLockfaresResults',
                'get_areWeInServicesBookingNoMode',

            ]),

            dd2faRequiredForFlow: function () {
                if (this.modulo === 'services') {
                    if (this.get_areWeInServicesBookingNoMode === true) {
                        return false;
                    }

                    return this.getServicesDd2faRequired === true;
                }

                return this.getBookingDd2faRequired === true;
            },

            isDdPayment: function () {
                const processObject = this.modulo === 'services' ?
                    this.getServicesProcessBookingObject :
                    this.getBookingProcessBookingObject;

                return processObject &&
                    processObject.payment &&
                    processObject.payment.type === 'DD';
            },

            areCheckboxesLocked: function () {
                return this.dd2faRequiredForFlow === true &&
                    this.isDdPayment === true &&
                    this.dd2faLocallyComplete === false;
            },

            dd2faPanelModulo: function () {
                return this.modulo;
            },

            dd2faServicesMode: function () {
                if (this.modulo === 'services' && this.get_areWeInServicesBookingNoMode === false) {
                    return 'registration';
                }

                if (this.modulo === 'services' && this.get_areWeInServicesBookingNoMode === true) {
                    return 'bookingno';
                }

                return null;
            },

            dd2faBookingKeyCode: function () {
                if (this.modulo === 'services' && this.get_areWeInServicesBookingNoMode === false) {
                    return this.getServicesTwoFaKeyCode || null;
                }

                if (this.modulo === 'booking') {
                    return this.getBookingLockfaresResults && this.getBookingLockfaresResults.keycode ?
                        this.getBookingLockfaresResults.keycode : null;
                }

                return null;
            },

            dd2faPhone: function () {
                const processObject = this.modulo === 'services' ?
                    this.getServicesProcessBookingObject :
                    this.getBookingProcessBookingObject;
                const customer = processObject && processObject.customer;

                if (!customer) {
                    return '';
                }

                return customer.phone || customer.mobile || '';
            },

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            checkedBoxes: function() {
                this.updateOverviewReadyForProcess();
            } // eof checkedBoxes()

        }, // eof watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoshowbookingsconfirmation' ('Call(s) done ...').
        * Note: Catch Event 'messsage' from iFrame here too.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> booking/overview/Overview.vue >>> created');
            this.checkedBoxes = [];
            this.actn_FlagBookingOverviewIsReadyForProcess(false);
            this.dd2faLocallyComplete = false;
            this.dd2faSecret = '';
            this.dd2faPinError = '';

            if (this.modulo === 'services' && this.get_areWeInServicesBookingNoMode === false) {
                this.dd2faKeyCode = this.getServicesTwoFaKeyCode || '';
            } else {
                this.dd2faKeyCode = '';
            }

            eventBus.$on('readytoshowbookingsconfirmation', this.onEmit_ReadyToShowConfirmation);
            eventBus.$on('readytoshowwirecardmodal', this.onEmit_ReadyToShowWireCardModal);
            eventBus.$on('readytodostepafterprebook', this.onEmit_ReadyToDoStepAfterPrebook);
            eventBus.$on('dd2fa-process-pin-error', this.onDd2faProcessPinError);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> booking/overview/Overview.vue >>> beforeDestroy');
            eventBus.$off('readytoshowbookingsconfirmation', this.onEmit_ReadyToShowConfirmation);
            eventBus.$off('readytoshowwirecardmodal', this.onEmit_ReadyToShowWireCardModal);
            eventBus.$off('readytodostepafterprebook', this.onEmit_ReadyToDoStepAfterPrebook);
            eventBus.$off('dd2fa-process-pin-error', this.onDd2faProcessPinError);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_FlagBookingOverviewIsReadyForProcess',
                'actn_setServicesProcessBookingResults',
                'actn_call_processBooking',
                'actn_call_registrationNewSpecials',
                'actn_call_wireCardEnrollPayment', // new: wirecard enrollment
                'actn_call_preBooking'
            ]),


            updateOverviewReadyForProcess: function () {
                const boxesOk = this.checkedBoxes.length === 2;
                const dd2faOk = !this.dd2faRequiredForFlow ||
                    !this.isDdPayment ||
                    this.dd2faLocallyComplete;

                this.actn_FlagBookingOverviewIsReadyForProcess(boxesOk && dd2faOk);
            },

            onDd2faConfirmed: function (payload) {
                this.dd2faLocallyComplete = true;
                this.dd2faSecret = payload.twoFaSecret;
                this.dd2faPinError = '';
                this.updateOverviewReadyForProcess();
            },

            onDd2faProcessPinError: function (payload) {
                if (!this.dd2faRequiredForFlow || !this.isDdPayment) {
                    return;
                }

                this.dd2faLocallyComplete = false;
                this.dd2faSecret = '';
                this.dd2faPinError = payload && payload.message ? payload.message : '';
                this.actn_FlagBookingOverviewIsReadyForProcess(false);
                this.openDd2faModal();
            },

            openDd2faModal: function () {
                this.$modal.show('dd-2fa-modal', {
                    modulo: this.dd2faPanelModulo,
                    rebookingMode: 'rebooking',
                    servicesMode: this.dd2faServicesMode,
                    bookingKeyCode: this.dd2faBookingKeyCode,
                    bookingIdentifier: null,
                    phone: this.dd2faPhone,
                    pinError: this.dd2faPinError,
                });
            },

            applyDd2faToPayment: function (payment) {
                if (!payment || payment.type !== 'DD' || !this.dd2faRequiredForFlow || !this.dd2faSecret) {
                    return;
                }

                payment.twoFaSecret = this.dd2faSecret;

                if (this.modulo === 'services' && this.dd2faKeyCode) {
                    payment.twoFaKeyCode = this.dd2faKeyCode;
                }
            },


            /******************************************************************* 'ServiceCalls - Shared'
            * ServiceCalls: 'Shared'
            *******************************************************************/
            /*******************************************************************
            * Call::'/site/getwebcomponent/'
            *
            * Desc:
            * Note:
            * ToDo: Get it into Booking Shared Store.
            *
            * @param {string} comptype (kind of Component)
            * @param
            */
            call_getwebcomponent: function (comptype) {

                var me = this,
                    hdrs = '';


                me.$toc('>>> booking/overview/Overview.vue >>> call_getwebcomponent');
                // >>> 1. Builds Object ----------------------------------------
                const requestParamObject = {
                    name: comptype
                };

                // >>> #267, Translation ---------------------------------------
                if (comptype === 'ABB') {
                    this.webcomponenttype = this.listpoint_abb[this.getCurrentLocale];
                }  else if (comptype === 'AGB') {
                    this.webcomponenttype = this.listpoint_agb[this.getCurrentLocale];
                }  else if (comptype === 'PCP') {
                    this.webcomponenttype = this.listpoint_pcp[this.getCurrentLocale];
                }  else if (comptype === 'PCPE') {
                    this.webcomponenttype = this.listpoint_sec[this.getCurrentLocale];
                } else {
                    this.webcomponenttype = comptype; // remember
                }

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/site/getwebcomponent/', requestParamObject)
                    .then(function(response) { // 'OK'
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                 me.$modal.show('size-modal2', { data: response.data });

                                me.$vp_um();
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_getwebcomponent()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: 'Overview Form' gets (not really) submitted.
            * Desc: Decides how to go on from here. Enrollment or Process.
            * Note: CreditCard - YES   => 'wirecard enroll payment'. (@first)
            * Note: CreditCard - NO    => 'normal process payment'.
            *
            * @param {Object} submitEvent (Event)
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    myParams = null,
                    myProcessObject = {
                        ticketBookingRQObject: null,
                        newSpecialsRQObject: null,
                        rebookingRQObject: null,
                        callName: null,
                    };


                me.$toc('>>> booking/overview/Overview.vue >>> onSubmit');
                // >>> 'Booking' ------------------------------------
                // if (this.modulo === 'booking') {
                //     // >>> Call(s) - Enrollment or Process? ---------
                //     if (this.getBookingProcessBookingObject.payment.ccPayment !== undefined) { // creditcard yes    => enrollment
                //         this.actn_call_wireCardEnrollPayment(this.createObjectForEnrollment());
                //     }
                //     if (this.getBookingProcessBookingObject.payment.ccPayment === undefined) { // creditcard no     => process
                //         this.actn_call_processBooking(this.createObjectForProcessNotCreditCard());
                //     }
                // }


                // >>> 'Services' -----------------------------------
                if (this.modulo === 'services') {
                    // >>> Call(s) - Enrollment or Process? ---------
                    if (this.getServicesProcessBookingObject.payment.ccPayment !== undefined) { // creditcard yes    => enrollment
                        // this.actn_call_wireCardEnrollPayment(this.createObjectForEnrollment()); // older
                        myProcessObject.newSpecialsRQObject = this.createObjectForProcessNotCreditCard();
                        myProcessObject.callName = 'BLANKO'; // 'TICKET_BOOKING', 'BLANKO', 'REBOOKING'

                        this.actn_call_preBooking(myProcessObject);
                    }

                    if (this.getServicesProcessBookingObject.payment.ccPayment === undefined) { // creditcard no     => process
                        myParams = this.createObjectForProcessNotCreditCard();
                        this.actn_call_registrationNewSpecials(myParams);
                    }
                }

            }, // eof onSubmit()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToShowConfirmation()
            *
            * Desc: Handle 'processBooking': Reaction (push 'Confirmation').
            * Note: Handle 'registrationNewSpecials': Reaction (push 'Confirmation').
            *
            */
            onEmit_ReadyToShowConfirmation: function() {

                let me = this,
                    options = {};


                me.$toc('>>> booking/overview/Overview.vue >>> onEmit_ReadyToShowConfirmation');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                setTimeout(function(){
                    me.$vp_um();
                    me.$vp_um();
                    me.$router.push({ path: '/confirmation/' + me.modulo });
                }, 500);

                setTimeout(function() {
                    me.$scrollTo('#scrollPointTop', 200, options);
                }, 600);

            }, // eo function onEmit_ReadyToShowConfirmation()


            /*******************************************************************
            * onEmit_ReadyToDoStepAfterPrebook()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_ReadyToDoStepAfterPrebook: function (data) {

                let me = this,
                    myProcessObject = null;


                me.$toc('>>> booking/overview/Overview.vue >>> onEmit_ReadyToDoStepAfterPrebook');
                // >>> ----------------------------------------
                // if (this.modulo === 'booking') {
                //     myProcessObject = this.createObjectForEnrollment();
                //     myProcessObject.transactionId = data.transactionId;
                //     this.actn_call_wireCardEnrollPayment(myProcessObject);
                // }


                // >>> ----------------------------------------
                if (this.modulo === 'services') {
                    // this.actn_call_registrationNewSpecials(this.createObjectForProcessCreditCard(event));
                    myProcessObject = this.createObjectForEnrollment();
                    myProcessObject.transactionId = data.transactionId;
                    this.actn_call_wireCardEnrollPayment(myProcessObject);
                }

            }, // eo function onEmit_ReadyToDoStepAfterPrebook()


            /*******************************************************************
            * onEmit_ReadyToShowWireCardModal()
            *
            * Desc: New CC Payment Way. WireCard. Enrollment.
            * Note: New Payment via Heidelpay.
            *
            */
            onEmit_ReadyToShowWireCardModal: function() {

                let me = this;


                me.$toc('>>> booking/overview/Overview.vue >>> onEmit_ReadyToShowWireCardModal');
                // me.$modal.show('wirecard-modal', { });

                // if (this.getBookingWireCardEnrollPaymentResults.provider === "heidelpay") {
                //     // gets set in: 'beforeOpenWirecardModal'
                //     // this.$refs.outputFrame.src = this.getBookingWireCardEnrollPaymentResults.redirectUrl;
                // }

                // if (this.getBookingWireCardEnrollPaymentResults.provider === "wirecard") {
                //     // submit
                //     setTimeout(function() {
                //         this.$refs.hiddenForm.submit();
                //     }.bind(this), 500);
                // }


                // >>> ----------------------------------------
                if (this.modulo === 'services') {
                    setTimeout(function () {
                        window.location.replace(this.getBookingWireCardEnrollPaymentResults.redirectUrl);
                    }.bind(this), 500);
                }

            }, // eo function onEmit_ReadyToShowWireCardModal()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * createObjectForEnrollment()
            *
            * Desc: Build Payload Object for Enrollment Call.
            * Note: Both: 'Booking', 'Services'.
            *
            * @return {Object}
            */
            createObjectForEnrollment: function (){

                var me = this,
                    myOverviewParams = {};


                me.$toc('>>> booking/overview/Overview.vue >>> createObjectForEnrollment');
                // >>> 'Booking' ------------------------------------
                if (this.modulo === 'booking') {
                    myOverviewParams = {...this.getBookingProcessBookingObject };

                    delete myOverviewParams.bookingKeyCode;
                    delete myOverviewParams.isReservation;
                    delete myOverviewParams.passengers;
                    delete myOverviewParams.voucherCodes;

                    myOverviewParams.amount = parseFloat(this.getBookingCartOutwardTotal, 10) + parseFloat(this.getBookingCartReturnTotal, 10);
                    myOverviewParams.comment = null;
                    myOverviewParams.currency = 'EUR';

                    myOverviewParams.payment.ccPayment.idProfiledPaymentData = null;
                    myOverviewParams.payment.ccPayment.refererIp = '129.12.12.12';
                    myOverviewParams.payment.comments = null;
                    myOverviewParams.payment.currencyCode = null;
                    myOverviewParams.payment.ddPayment = null;
                    myOverviewParams.payment.ndPayment = null;
                    myOverviewParams.payment.refererIP = '129.12.12.12';

                    if (myOverviewParams.payment.ccPayment.cc_brand === 'MASTER') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'mastercard';
                    }
                    if (myOverviewParams.payment.ccPayment.cc_brand === 'VISA') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'visa';
                    }
                    if (myOverviewParams.payment.ccPayment.cc_brand === 'AMEX') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'amex';
                    }
                }


                // >>> 'Services' -----------------------------------
                if (this.modulo === 'services') {
                    myOverviewParams = { ...this.getServicesProcessBookingObject };

                    // >>> Edit Object ------------------------------
                    for (var i = 0; i < myOverviewParams.passengers.length; i++) {
                        delete myOverviewParams.passengers[i].id_pax;
                    }

                    delete myOverviewParams.bookingKeyCode;
                    delete myOverviewParams.isReservation;
                    delete myOverviewParams.passengers;
                    delete myOverviewParams.voucherCodes;

                    myOverviewParams.amount = parseFloat(this.getBookingCartOutwardTotal, 10) + parseFloat(this.getBookingCartReturnTotal, 10);
                    myOverviewParams.comment = null;
                    myOverviewParams.currency = 'EUR';

                    myOverviewParams.payment.ccPayment.idProfiledPaymentData = null;
                    myOverviewParams.payment.ccPayment.refererIp = '129.12.12.12';
                    myOverviewParams.payment.comments = null;
                    myOverviewParams.payment.currencyCode = null;
                    myOverviewParams.payment.ddPayment = null;
                    myOverviewParams.payment.ndPayment = null;
                    myOverviewParams.payment.refererIP = '129.12.12.12';

                    if (myOverviewParams.payment.ccPayment.cc_brand === 'MASTER') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'mastercard';
                    }
                    if (myOverviewParams.payment.ccPayment.cc_brand === 'VISA') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'visa';
                    }
                    if (myOverviewParams.payment.ccPayment.cc_brand === 'AMEX') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'amex';
                    }
                }


                return myOverviewParams;

            }, // eo function createObjectForEnrollment()


            /*******************************************************************
            * createObjectForProcessNotCreditCard()
            *
            * Desc: Build Payload Object for Process Call. NOT CC!
            * Note: Both: 'Booking', 'Services'.
            *
            * @return {Object}
            */
            createObjectForProcessNotCreditCard: function (){

                var me = this,
                    myOverviewParams = {};



                me.$toc('>>> booking/overview/Overview.vue >>> createObjectForProcessNotCreditCard');
                // >>> 'Booking' ------------------------------------
                if (this.modulo === 'booking') {
                    myOverviewParams = { ...this.getBookingProcessBookingObject };
                }


                // >>> 'Services' -----------------------------------
                if (this.modulo === 'services') {
                    myOverviewParams = { ...this.getServicesProcessBookingObject };


                    let deepClone = JSON.parse(JSON.stringify(this.getServicesValidatePassengersObject.passengers)); // again catch from validate object Bec. it can still get deleted in cart here
                    myOverviewParams.passengers = deepClone; // catch (validated) pax & srvcs


                    // >>> Edit Object ------------------------------
                    for (var i = 0; i < myOverviewParams.passengers.length; i++) {
                        delete myOverviewParams.passengers[i].id_pax;
                    }
                }

                if (myOverviewParams.payment) {
                    this.applyDd2faToPayment(myOverviewParams.payment);
                }


                return myOverviewParams;

            }, // eo function createObjectForProcessNotCreditCard()


            /*******************************************************************
            * createObjectForProcess()
            *
            * Desc: Build Payload Object for Process Call. CC ONLY!
            * Note: Both: 'Booking', 'Services'.
            *
            * @param {Object} event (Event)
            * @return {Object}
            */
            createObjectForProcessCreditCard: function (event){

                var me = this,
                    myOverviewParams = {};


                me.$toc('>>> booking/overview/Overview.vue >>> createObjectForProcessCreditCard');
                // >>> 'Booking' ------------------------------------
                if (this.modulo === 'booking') {
                    myOverviewParams = {...this.getBookingProcessBookingObject };

                    delete myOverviewParams.payment.ccPayment.cc_brand;
                    delete myOverviewParams.payment.ccPayment.cc_cvc;
                    delete myOverviewParams.payment.ccPayment.cc_expiry_month;
                    delete myOverviewParams.payment.ccPayment.cc_expiry_year;
                    delete myOverviewParams.payment.ccPayment.cc_holder;
                    delete myOverviewParams.payment.ccPayment.cc_number;
                    delete myOverviewParams.payment.ccPayment.idProfiledPaymentData;
                    delete myOverviewParams.payment.ccPayment.refererIp;

                    myOverviewParams.payment.ccPayment.transactionId = event.data.transactionId;
                }


                // >>> 'Services' -----------------------------------
                if (this.modulo === 'services') {
                    myOverviewParams = {...this.getServicesProcessBookingObject };

                    // >>> Edit Object ------------------------------
                    for (var i = 0; i < myOverviewParams.passengers.length; i++) {
                        delete myOverviewParams.passengers[i].id_pax;
                    }

                    delete myOverviewParams.payment.ccPayment.cc_brand;
                    delete myOverviewParams.payment.ccPayment.cc_cvc;
                    delete myOverviewParams.payment.ccPayment.cc_expiry_month;
                    delete myOverviewParams.payment.ccPayment.cc_expiry_year;
                    delete myOverviewParams.payment.ccPayment.cc_holder;
                    delete myOverviewParams.payment.ccPayment.cc_number;
                    delete myOverviewParams.payment.ccPayment.idProfiledPaymentData;
                    delete myOverviewParams.payment.ccPayment.refererIp;

                    myOverviewParams.payment.ccPayment.transactionId = event.data.transactionId;

                }


                return myOverviewParams;

            }, // eo function createObjectForProcessCreditCard()



            /*******************************************************************
            * Modals:
            *******************************************************************/
            /*******************************************************************
            * Modal - Events - beforeOpen
            *
            * Desc:
            * Note: Catches 'data' Object from $modal.show.
            *
            */
            beforeOpen: function(event) {

                this.sections = event.params.data.sections;

            }, // eof beforeOpen()


            /*******************************************************************
            * Modal - Events - beforeClose
            *
            * Desc: Empty Sections again.
            * Note:
            *
            */
            beforeClose: function() {

                this.sections = [];

            }, // eof beforeClose()

        }, // eof beforeCloseirecardModal()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #flight-details .flights {
        padding-bottom: 0px;
    }
    #flight-details .flights .first-flight .logo:after {
        bottom: 23px;
    }

    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }
    dl.term-description dt {
        color: #9e4d84;
    }
    .tab-container ul.tabs li.active > a,
    .tab-container ul.tabs li:hover > a {
        color: #9e4d84;
    }

    /* Price Table */
    .cruise-itinerary td {
        line-height: 2.5em;
        border: 1px solid #f5f5f5;
    }
    .booking-details .other-details {
        background-color: #f5f5f5;
    }
    .booking-details .other-details .total-price-value {
        font-size: 1.9167em;
    }
    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }
    .booking-details .other-details dt,
    .booking-details .other-details dd {
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }

    .icon-box.style9 > i {
        background: #9e4d84;
    }

    .hotel-faqs .topics li.active,
    #flight-fare-rules .topics li.active {
        background: #9e4d84;
    }

    /* Modal */
    .size-modal2-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
        padding-right: 50px;
    }
    .v--modal-overlay[data-modal='size-modal2'] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;
    }
    .demo-modal-class {
        border-radius: 5px;
        background: #f7f7f7;
        box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
    }

    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #0082c8;
    }

    .dd-2fa-checkboxes-wrap {
        position: relative;
    }

    .dd-2fa-checkboxes-wrap--locked .form-group,
    .dd-2fa-checkboxes-wrap--locked .container {
        pointer-events: none;
        user-select: none;
    }

    .dd-2fa-checkboxes-lock-overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px 16px;
        background: rgba(255, 255, 255, 0.78);
        cursor: pointer;
        border-radius: 4px;
    }

    .dd-2fa-checkboxes-lock-message {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        max-width: 340px;
        padding: 22px 28px;
        text-align: center;
        background: #fff;
        border: 2px solid #d35400;
        border-radius: 8px;
        box-shadow: 0 6px 20px rgba(45, 62, 82, 0.14);
    }

    .dd-2fa-checkboxes-lock-message i {
        font-size: 28px;
        color: #d35400;
    }

    .dd-2fa-checkboxes-lock-message strong {
        font-size: 15px;
        color: #2d3e52;
        line-height: 1.3;
    }

    .dd-2fa-checkboxes-lock-message span {
        font-size: 13px;
        color: #666;
        line-height: 1.4;
    }

    .dd-2fa-banner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 16px 20px;
        border: 2px solid #d35400;
        border-radius: 8px;
        background: #fffaf5;
    }

    .dd-2fa-banner--done {
        border-color: #3a7d1e;
        background: #f6fbf4;
    }

    .dd-2fa-banner__body {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .dd-2fa-banner__step {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 3px;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: #fde8e0;
        color: #c0392b;
    }

    .dd-2fa-banner--done .dd-2fa-banner__step {
        background: #e3f2de;
        color: #3a7d1e;
    }

    .dd-2fa-banner__content {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .dd-2fa-banner__content > i {
        font-size: 24px;
        color: #d35400;
        flex-shrink: 0;
    }

    .dd-2fa-banner--done .dd-2fa-banner__content > i {
        color: #3a7d1e;
    }

    .dd-2fa-banner__content strong {
        font-size: 15px;
        color: #2d3e52;
        line-height: 1.3;
    }

    .dd-2fa-banner__action {
        flex-shrink: 0;
    }

    .dd-2fa-open-btn {
        white-space: nowrap;
    }

    .dd-2fa-done {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        color: #3a7d1e;
        font-weight: 700;
        font-size: 14px;
    }

    @media only screen and (max-width: 600px) {
        .dd-2fa-banner {
            flex-direction: column;
            align-items: stretch;
            text-align: center;
        }

        .dd-2fa-banner__action {
            width: 100%;
        }

        .dd-2fa-open-btn {
            width: 100%;
        }
    }



    /* a {
            color: rgb(119, 41, 85);
        } */

    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.5em;
        }
        h2 {
            font-size: 1.4em;
        }
        button.btn-large,
        input[type='button'].button.btn-large,
        a.button.btn-large {
            font-size: 1em;
        }

        .booking-section {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }
</style>
